import script from "./SearchPageFilterOptions.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchPageFilterOptions.vue?vue&type=script&setup=true&lang=ts"

import "@/assets/css/search-page/search-page.css?vue&type=style&index=0&id=f82406f4&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f82406f4"]])

export default __exports__